import * as constants from './constants';
import {
    fromJS
} from 'immutable';
const defaultState = fromJS({
    settingInfo:{},
    data: {
        project:[],
        live:[],
        experiment:[],
    },
    userinfo: {"user_name":"", "user_id": '', "tenant":'' , "realname":""},
    regneedphone: ''
})

export default (state = defaultState, action) => {
    switch (action.type) {
    
        case constants.CHANGE_HOME_DATA:
            return state.merge({
                data: action.data
            });
        case constants.CHANGE_SETTING_DATA:
            return state.merge({
                settingInfo:action.settingInfo
            });
        case constants.CHANGE_USERINFO:
            return state.merge({
                userinfo:action.userinfo
            });
        case constants.CHANGE_REGPHONE:
            return state.merge({
                regneedphone: action.regneedphone
            });
        default:
            return state;
    }
}